/* eslint-disable @typescript-eslint/no-unused-vars */
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { BaseCrudService } from '@t-llevo/common-ui';
import { Environment, ResponseData } from '@t-llevo/util';
import { Version } from '../../common/models/Version';
import { VersionResponse } from '../models/responses/VersionResponse';
import { VersionMapper } from '../mappers/VersionMapper';
import { apiVersionControlRoutes as apiRoutes } from '../routes/api-version-control-routes';

@Injectable()
export class VersionControlService extends BaseCrudService<
  Version,
  VersionResponse[]
> {
  constructor(http: HttpClient, @Inject(Environment) env: Environment) {
    super(env, http);
  }

  override transform(data: VersionResponse[]): ResponseData<Version> {
    return {
      count: 0,
      results: data.map((version) => VersionMapper(version)),
      limit: '',
      page: '',
    };
  }

  createVersion(
    params: Omit<VersionResponse, 'createdAt' | 'updatedAt' | '_id'>,
  ) {
    return this.http.post<VersionResponse>(
      `${this.env.apiUrl}${apiRoutes.routeVersion}`,
      params,
    );
  }

  getVersions() {
    return this.http.get<VersionResponse[]>(
      `${this.env.apiUrl}${apiRoutes.routeVersion}`,
    );
  }

  getLastVersionByPackageName(packageName: string) {
    return this.http.get<VersionResponse>(
      this.env.apiUrl + apiRoutes.routeLastVersion + packageName,
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateVersionById(
    params: Omit<VersionResponse, 'createdAt' | 'updatedAt' | '_id'>,
    id: string,
  ) {
    return this.http.patch(
      `${this.env.apiUrl}${apiRoutes.routeVersion}/${id}`,
      params,
    );
  }

  deleteVersionById(id: string) {
    return this.http.delete(
      `${this.env.apiUrl}${apiRoutes.routeVersion}/${id}`,
    );
  }
}
